var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeveragedIndexesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 333.3 333.3",
    style: {
      enableBackground: "new 0 0 333.3 333.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,333.3H140c-18.4,0-33.3-14.9-33.3-33.3v-73.3H33.3C14.9,226.7,0,211.7,0,193.3v-160C0,14.9,14.9,0,33.3,0 h160c18.4,0,33.3,14.9,33.3,33.3v73.3H300c18.4,0,33.3,14.9,33.3,33.3v160C333.3,318.4,318.4,333.3,300,333.3z M173.3,266.7h93.3 v-93.3h-73.3c-18.4,0-33.3-14.9-33.3-33.3V66.7H66.7V160H140c18.4,0,33.3,14.9,33.3,33.3V266.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeveragedIndexesIcon);
export default __webpack_public_path__ + "static/media/leveraged_indexes_icon.bd8e3c81a481d8bced36666edcc9ed8c.svg";
export { ForwardRef as ReactComponent };